import React from "react";

import type { MonitorCheckStatusExternalSilencingRule } from "../../../../../../common/openapi";

import { ActiveRuleAlert } from "./common/active-rule-alert";
import { AppliesTo } from "./common/applies-to";
import { CannotUnmuteAlert } from "./common/cannot-unmute-alert";
import { ExternalRuleTiming } from "./common/external-rule-timing";
import { SilencingNote } from "./common/silencing-note";

export function ExternalLiveWithoutSelector({ rule }: { rule: MonitorCheckStatusExternalSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<section className="flex flex-col gap-4">
				<ActiveRuleAlert />
				<CannotUnmuteAlert />
			</section>
			<ExternalRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
